import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router';


function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}

export default function AllCuisineBreadcrumbs() {

  let navigate = useNavigate();

  const breadcrumbs = [
    
      <Link underline="hover" key="1" color="primary"  onClick={()=> navigate('/')} sx={{color: "#2B817B", fontSize: "14px", fontWeight: "400"}}>
      Home
    </Link>,
    
    <Link
      underline="hover"
      key="2"
      color="primary"
      
      onClick={()=> navigate('/allmenu')}
      sx={{color: "#2B817B", fontSize: "14px", fontWeight: "400"}}
    >
      AllMenu
    </Link>,
    <Link
    underline="hover"
    key="2"
    color="primary"
    sx={{color: "#9EA3AE", fontSize: "14px", fontWeight: "400"}}
  >
    All Cuisine
  </Link>

  ];

  return (
    <Stack spacing={2}>

      <Breadcrumbs
      
        separator={<NavigateNextIcon fontSize="small" width="4.73px" height="10.56px" />}
        aria-label="breadcrumb"
        color="primary"
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
}
